import { useKernelApi } from 'infrastructure/api';

export const useDomainsService = () => {
  const { sendPostRequest } = useKernelApi();

  const findAllDomains = async (request: any) => {
    const response = await sendPostRequest('/domains/search', request);
    const json = await response.json();

    return json;
  };

  const createDomain = async (request: any) => {
    const response = await sendPostRequest('/domains', request);
    const json = await response.json();

    return json;
  };

  return {
    createDomain,
    findAllDomains,
  };
};
